module.exports = __webpack_public_path__ + "img/RESPINS.98926ea8.png";